import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'

const fetchInfo = async () => {
  const { params, query } = router.currentRoute.value
  return await apiHelperService.get(`/api/icaRequest/draft/prepareCitizenEidaDraft`, {
    params: {
      serviceTransactionId: params?.serviceId,
      personUN: query?.personUN
    }
  })
}
const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()
  const { dateOfBirth } = res
  // Server side need all the response values to be set in the form
  formStore.draft.request = {
    ...formStore.draft.request,
    ...res
  }
  formStore.form.setValues({
    ...res
  })

  formStore.extraMap.dateOfBirth = dateOfBirth
}

const handleShowCurrentMobileNumber = () => {
  const user = useAuthStore().user
  const formStore = useFormStore()
  if (
    !lookups.allowedApplicationsForTawzeeChanges.includes(user.applicationId) &&
    !lookups.allowedApplicationsForZajelChanges.includes(user.applicationId)
  ) {
    formStore.extraMap.showCurrentMobileNumber = false
  }
}

const handleEnableNewSharedUserAddress = () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceTransactionId
  const {
    application: {
      resident,
      citizen,
      gcc,
      gcc_citizen,
      visaHolder,
      dubaiResident,
      establishment,
      familyMemberResidencyHolder
    },
    ServiceTransactions: { issuePassport, replacePassport, passportLosing }
  } = lookups
  const user = authStore.user

  const isNotInRoleList = ![
    resident,
    citizen,
    gcc,
    gcc_citizen,
    visaHolder,
    dubaiResident,
    establishment,
    familyMemberResidencyHolder
  ].includes(user.applicationId)

  const isInService = [issuePassport, replacePassport, passportLosing].includes(
    serviceTransactionId
  )

  if (isNotInRoleList || isInService) {
    formStore.extraMap.enableNewSharedUserAddreses = false
  }
}

export default async function () {
  const formStore = useFormStore()
  try {
    formStore.extraMap = {
      dateOfBirth: null,
      identityNumber: null,
      unifiedNumber:
        router.currentRoute.value.query.sponsoredUN || router.currentRoute.value.query.personUN,
      showCurrentMobileNumber: true,
      enableNewSharedUserAddreses: true,
      urgentServiceFlag: false,
      haveExemptions: false,
      isInCompleteDraftFlag: false,
      disableDeliveryMethod: false,
      disableDeliveryInfoSection: false,
      showMobileNumbersListForTawzee: client_config.showMobileNumbersListForTawzee,
      enableNewDeliverySection: client_config.enableNewDeliverySection,
      enableZajelDelivery: client_config.enableZajelDelivery,
      disableTawzeaDeliveryCity: false,
      showChangePersonPhoto: false,
      showBoxNumberMsg: false,
      showAmerDeliveryAddress: false,
      disableAmerDeliveryCity: true,
      disableAmerDeliveryEmirate: false,
      disableZajelDeliveryArea: false,
      disableTawzeaDeliveryArea: false
    }

    handleEnableNewSharedUserAddress()
    handleShowCurrentMobileNumber()
    await initInfo()
  } catch (error) {
    console.error('use561Preload', error)
  }
}
